import React, { Component } from "react";
import classnames from "classnames";

class MarketplaceHeader extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={
	
    }
	
}
 
componentDidMount(){
	
}

  render() {
	 return (
		<div className={classnames({'marketplace_header': true, 'just_logo_header': !this.props.showOptions})}>
			<div className="market_logo"></div>
			{ this.props.showOptions &&
				<div className="inline_header_options">
					<div className={"market_option market_option_widder " + ( this.props.chosenMenu === 'Classes' ? "active" : "" )} onClick={() => this.props.updateStateFromChild({chosenMenu: 'Classes'})}>
						<div className="market_icon classes_icon"></div>
						<div className="market_title">Classes</div>
					</div>
					{ /* <div className={"market_option " + ( this.props.chosenMenu === 'Social' ? "active" : "" )} onClick={() => this.props.updateStateFromChild({chosenMenu: 'Social'})}>
						<div className="market_icon social_icon"></div>
						<div className="market_title">Social</div>
					</div>
					<div className={"market_option " + ( this.props.chosenMenu === 'Shop' ? "active" : "" )} onClick={() => this.props.updateStateFromChild({chosenMenu: 'Shop'})}>
						<div className="market_icon shop_icon"></div>
						<div className="market_title">Shop</div>
					</div> */ }
					<div className={"market_option market_option_widder " + ( this.props.chosenMenu === 'My Profile' ? "active" : "" )} onClick={() => this.props.updateStateFromChild({chosenMenu: 'My Profile'})}>
						<div className="market_icon profile_icon"></div>
						<div className="market_title">My Profile</div>
					</div>
					<div className={"market_option market_option_widder " + ( this.props.chosenMenu === 'Settings' ? "active" : "" )} onClick={() => this.props.updateStateFromChild({chosenMenu: 'Settings'})}>
						<div className="market_icon settings_icon_mp"></div>
						<div className="market_title">Settings</div>
					</div>
				</div>
			}
		</div>
    );
  }
}
export default MarketplaceHeader;
